<div class="player-profile-tab-content">
  <app-loading [active]="isLoading" [center]="true"/>
  <app-message [active]="!!errorMsg" [message]="errorMsg"/>

  @if (data && !isLoading) {
    <div class="">
      <div class="text-lg flex align-items-center gap-2 pb-3">
        <i class="text-xl pi pi-trophy text-gold"></i>
        {{scoreTotal}}
      </div>

      <div class="pb-3">
        @for (achievement of data; track achievement.id) {
          <div class="py-1">
            <!--<div class="flex shadow-1 justify-content-center align-items-stretch achievement-card"
                 [class.achievement-unlocked]="!!achievement.unlocked">
              <div class="flex-none font-bold text-gray-400 text-center achievement-card-points">
                {{achievement.points}}
              </div>
              <div class="flex-auto">
                <div class="text-nm md:text-lg" [class.text-gray-500]="!achievement.unlocked">
                  {{achievement.name}}
                </div>
                <div class="text-sm md:text-nm achievements-nowrap text-gray-400"
                     [class.text-gray-600]="!achievement.unlocked">
                  {{achievement.description}}
                </div>
              </div>
            </div>-->
            <div class="flex justify-content-center align-items-stretch achievement-card shadow-1"
                 [class.achievement-unlocked]="!!achievement.unlocked">
              <div class="flex achievement-card-points justify-content-center align-items-center relative font-bold text-gray-400">
                {{achievement.points}}
              </div>
              <div class="flex-1 justify-content-center flex-1 achievement-card-content align-items-center pt-2 pb-2 relative">
                <div class="text-nm md:text-lg"
                     [class.text-gray-500]="!achievement.unlocked">
                  {{achievement.name}}
                </div>
                <div class="w-full cell-nowrap pt-1 text-gray-400 text-sm md:text-nm"
                     [class.text-gray-600]="!achievement.unlocked">
                  {{achievement.description}}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
            <!--
            description
            seen
            unlocked
            playerAchievements
            -->

    </div>
  }
</div>
